// src/components/skins/dashboard-bess.js
export class DashboardBessHtml {
  bessskin() {
    return `
      <div class="container-layout d-grid grid-2 dashboard-bess-v2">
        <!-- BESS Summary Data -->
        <div class="container-column dashboard-panel dashboard-chart-card">
          <div class="column-header dashboard-v2-chart-header">
            <div class="header-title has-icon">
              <span class="iconify" data-icon="mingcute:performance-line"></span>
              <h3>BESS Summary Data</h3>
            </div>
            <div class="dashboard-v2-chart-actions">
              <button class="chip active" data-chart-control="bess-summary-tab" data-tab="core">Core</button>
              <button class="chip" data-chart-control="bess-summary-tab" data-tab="energy">Energy</button>
            </div>
          </div>
          <div class="container-body dashboard-v2-list dashboard-v2-controls-list bess-summary-list" data-bess-summary-list>
            <div data-bess-summary-item data-tab="core"><span>State of Charge (%)</span><strong data-register="soc">0.00</strong></div>
            <div data-bess-summary-item data-tab="core"><span>Available Banks</span><strong data-register="bessavailablebanks">0</strong></div>
            <div data-bess-summary-item data-tab="core"><span>Available Charge Power (MW)</span><strong data-register="bessavailablechargepower">0.00</strong></div>
            <div data-bess-summary-item data-tab="core"><span>Available Discharge Power (MW)</span><strong data-register="bessavailabledischargepower">0.00</strong></div>
            <div data-bess-summary-item data-tab="core"><span>BESS Active Alarms (#)</span><strong data-register="bessalarms">0</strong></div>
            <div data-bess-summary-item data-tab="energy"><span>Charge Energy (MWh)</span><strong data-register="besschargeenergy">0.00</strong></div>
            <div data-bess-summary-item data-tab="energy"><span>Discharge Energy (MWh)</span><strong data-register="bessdischargeenergy">0.00</strong></div>
            <div data-bess-summary-item data-tab="energy"><span>Charge Energy Today (MWh)</span><strong data-register="besschargeenergytoday">0.00</strong></div>
            <div data-bess-summary-item data-tab="energy"><span>Discharge Energy Today (MWh)</span><strong data-register="bessdischargeenergytoday">0.00</strong></div>
            <div data-bess-summary-item data-tab="energy"><span>Net Energy (MWh)</span><strong data-register="bessnetenergy">0.00</strong></div>
            <div data-bess-summary-item data-tab="energy"><span>Energy Throughput (MWh)</span><strong data-register="bessenergythroughput">0.00</strong></div>
            <div data-bess-summary-item data-tab="energy"><span>Round-trip Efficiency (%)</span><strong data-register="bessrtefficiency">0.00</strong></div>
          </div>
        </div>

        <!-- ARRAY SUMMARY DATA -->
        <div class="container-column dashboard-panel dashboard-chart-card array-summary-card">
          <div class="column-header dashboard-v2-chart-header">
            <div class="header-title has-icon">
              <h3>ARRAY SUMMARY DATA</h3>
            </div>
            <div class="dashboard-v2-chart-actions">
              <button class="full-screen-button dashboard-v2-fullscreen-btn chip" title="Fullscreen">
                <span class="iconify" data-icon="mdi:fullscreen" style="font-size:14px;pointer-events:none;"></span>
              </button>
            </div>
          </div>
          <div class="container-body">
            <div class="table-responsive">
              <table class="has-min-width">
                <thead>
                  <tr>
                    <th>CIRCUIT</th>
                    <th>kW</th>
                    <th>kVAr</th>
                    <th>MWh (TOTAL)</th>
                    <th>MWh/DAY</th>
                    <th>STATUS</th>
                    <th>ALARM</th>
                  </tr>
                </thead>
                <tbody class="arrayBody">
                  <!-- Filled dynamically by JS -->
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- REMOTE CONTROL (Dynamic BESS Columns) -->
        <div class="container-column dashboard-panel dashboard-chart-card remote-control">
          <div class="column-header dashboard-v2-chart-header">
            <div class="header-title has-icon">
              <span class="iconify" data-icon="mingcute:performance-line"></span>
              <h3>Remote Control</h3>
            </div>
            <div class="dashboard-v2-chart-actions">
              <button class="full-screen-button dashboard-v2-fullscreen-btn chip" title="Fullscreen">
                <span class="iconify" data-icon="mdi:fullscreen" style="font-size:14px;pointer-events:none;"></span>
              </button>
            </div>
          </div>
          <div class="container-body">
            <div class="table-responsive">
              <table class="has-min-width">
                <thead>
                  <tr>
                    <th colspan="2"></th>
                    <!-- BESS columns injected by JS -->
                  </tr>
                </thead>
                <tbody>
                  <!-- Rows injected by JS -->
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- BESS Alarms -->
        <div class="container-column dashboard-panel dashboard-chart-card bess-alarms-card">
          <div class="column-header dashboard-v2-chart-header">
            <div class="header-title has-icon">
              <h3>BESS Active Alarms</h3>
            </div>
            <div class="dashboard-v2-chart-actions">
              <button class="chip" data-action="view-bess-alarms">View All Alarms</button>
            </div>
          </div>
          <div class="container-body bess-alarms-body">
            <div class="bess-alarms-table-wrap">
              <table class="bess-alarms-table">
                <thead>
                  <tr>
                    <th>Time</th>
                    <th>Severity</th>
                    <th>Message</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody data-bess-alarms-body>
                  <tr>
                    <td colspan="4" class="bess-alarms-empty">No active BESS alarms</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- PCS SOC Comparison -->
        <div class="container-column dashboard-panel dashboard-chart-card">
          <div class="column-header dashboard-v2-chart-header">
            <div class="header-title has-icon">
              <h3>PCS SOC Comparison</h3>
            </div>
            <div class="dashboard-v2-chart-actions">
              <select class="chip" data-chart-control="type" data-chart-id="pcs_soc_comparison">
                <option value="lines">Line</option>
                <option value="lines+markers">Line + Markers</option>
                <option value="bar">Bar</option>
                <option value="area">Area</option>
                <option value="spline">Spline</option>
              </select>
              <button class="full-screen-button dashboard-v2-fullscreen-btn chip" title="Fullscreen">
                <span class="iconify" data-icon="mdi:fullscreen" style="font-size:14px;pointer-events:none;"></span>
              </button>
            </div>
          </div>
          <div class="container-body">
            <div class="column-chart" id="pcs_soc_comparison"></div>
          </div>
        </div>

        <!-- PCS Power Comparison -->
        <div class="container-column dashboard-panel dashboard-chart-card">
          <div class="column-header dashboard-v2-chart-header">
            <div class="header-title has-icon">
              <h3>PCS Power Comparison</h3>
            </div>
            <div class="dashboard-v2-chart-actions">
              <select class="chip" data-chart-control="type" data-chart-id="pcs_power_comparison">
                <option value="lines">Line</option>
                <option value="lines+markers">Line + Markers</option>
                <option value="bar">Bar</option>
                <option value="area">Area</option>
                <option value="spline">Spline</option>
              </select>
              <button class="full-screen-button dashboard-v2-fullscreen-btn chip" title="Fullscreen">
                <span class="iconify" data-icon="mdi:fullscreen" style="font-size:14px;pointer-events:none;"></span>
              </button>
            </div>
          </div>
          <div class="container-body">
            <div class="column-chart" id="pcs_power_comparison"></div>
          </div>
        </div>

        <!-- PCS Availability Comparison -->
        <div class="container-column dashboard-panel dashboard-chart-card">
          <div class="column-header dashboard-v2-chart-header">
            <div class="header-title has-icon">
              <h3>PCS Availability Comparison</h3>
            </div>
            <div class="dashboard-v2-chart-actions">
              <button class="chip active" data-chart-control="preset" data-chart-id="pcs_avalability_comparison" data-preset="capacity">Capacity</button>
              <button class="chip" data-chart-control="preset" data-chart-id="pcs_avalability_comparison" data-preset="soc">SOC</button>
              <select class="chip" data-chart-control="type" data-chart-id="pcs_avalability_comparison">
                <option value="lines">Line</option>
                <option value="lines+markers">Line + Markers</option>
                <option value="bar">Bar</option>
                <option value="area">Area</option>
                <option value="spline">Spline</option>
              </select>
              <button class="full-screen-button dashboard-v2-fullscreen-btn chip" title="Fullscreen">
                <span class="iconify" data-icon="mdi:fullscreen" style="font-size:14px;pointer-events:none;"></span>
              </button>
            </div>
          </div>
          <div class="container-body">
            <div class="column-chart" id="pcs_avalability_comparison"></div>
          </div>
        </div>

        <!-- Average Temperature Comparison -->
        <div class="container-column dashboard-panel dashboard-chart-card">
          <div class="column-header dashboard-v2-chart-header">
            <div class="header-title has-icon">
              <h3>Average Temperature Comparison</h3>
            </div>
            <div class="dashboard-v2-chart-actions">
              <select class="chip" data-chart-control="type" data-chart-id="average_temp_comparison">
                <option value="lines">Line</option>
                <option value="lines+markers">Line + Markers</option>
                <option value="bar">Bar</option>
                <option value="area">Area</option>
                <option value="spline">Spline</option>
              </select>
              <button class="full-screen-button dashboard-v2-fullscreen-btn chip" title="Fullscreen">
                <span class="iconify" data-icon="mdi:fullscreen" style="font-size:14px;pointer-events:none;"></span>
              </button>
            </div>
          </div>
          <div class="container-body">
            <div class="column-chart" id="average_temp_comparison"></div>
          </div>
        </div>
      </div>
    `;
  }
}